export const AnimationTiming = {
  TooltipHoverDelaySeconds: 0.2,
};
